"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.freeze");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.object.values");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LabeledDataCollectionBreak = exports.rows = exports.type = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LabeledData = _interopRequireDefault(require("./../LabeledData/LabeledData"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var type = Object.freeze({
  HORIZONTAL: '--is-horizontal',
  VERTICAL: '--is-vertical',
  BREAK: '--is-breakable'
});
exports.type = type;
var rows = Object.freeze({
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4
});
exports.rows = rows;

var LabeledDataCollectionBreak = function LabeledDataCollectionBreak() {
  return /*#__PURE__*/_react.default.createElement("div", {
    role: "presentation",
    className: "labeled-data-collection-break"
  });
};
/**
 * @example
 * <LabeledDataCollection
	data={[{term: 'foo', definition: 'bar'}]}
	type="--is-vertical" />
 */


exports.LabeledDataCollectionBreak = LabeledDataCollectionBreak;

var LabeledDataCollection = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(LabeledDataCollection, _React$PureComponent);

  var _super = _createSuper(LabeledDataCollection);

  function LabeledDataCollection() {
    _classCallCheck(this, LabeledDataCollection);

    return _super.apply(this, arguments);
  }

  _createClass(LabeledDataCollection, [{
    key: "render",
    value: function render() {
      var _this = this;

      var rowClass = this.props.rows ? "--rows-".concat(this.props.rows) : null;
      var classes = (0, _classnames.default)('labeled-data-collection', this.props.type, rowClass, {
        '--stretch-lines': this.props.stretchLines
      });
      var items = [];

      if (this.props.children) {
        items = this.props.children;
      } else {
        items = this.props.data.map(function (set, i) {
          return /*#__PURE__*/_react.default.createElement(_LabeledData.default, {
            key: i,
            term: set.term,
            definition: set.definition,
            type: set.type,
            isSmall: set.isSmall || _this.props.isSmall || false
          });
        });
      }

      return /*#__PURE__*/_react.default.createElement("dl", {
        className: classes
      }, items);
    }
  }], [{
    key: "Type",
    // eslint-disable-line react/no-multi-comp
    get: function get() {
      return type;
    }
  }, {
    key: "Rows",
    get: function get() {
      return rows;
    }
  }]);

  return LabeledDataCollection;
}(_react.default.PureComponent);

_defineProperty(LabeledDataCollection, "propTypes", {
  /***
   * Ignored if children are passed in
   */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    term: _propTypes.default.string,
    definition: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]) // Definition is either string or node

  })),
  type: _propTypes.default.oneOf(Object.values(type)),

  /***
   * Applys flex-grow: 1 to the children to space them out of evenly on a line
   */
  stretchLines: _propTypes.default.bool,
  children: _propTypes.default.node,
  isSmall: _propTypes.default.bool,
  rows: _propTypes.default.oneOf(Object.values(rows))
});

_defineProperty(LabeledDataCollection, "defaultProps", {
  type: type.HORIZONTAL,
  data: [],
  stretchLines: false,
  children: null,
  isSmall: false,
  rows: null
});

var _default = LabeledDataCollection;
exports.default = _default;
//# sourceMappingURL=LabeledDataCollection.js.map